import React, { useState } from 'react';

interface SuggestionButton {
  text: string;
  action: string;
}

interface SuggestionButtonsData {
  buttons: SuggestionButton[];
}

interface SuggestionButtonsProps {
  data?: SuggestionButtonsData;
  onSendMessage?: (message: string) => void;
}

export const SuggestionButtons: React.FC<SuggestionButtonsProps> = ({
  data,
  onSendMessage,
}) => {
  const [clicked, setClicked] = useState(false);

  if (!data?.buttons?.length || clicked) {
    return null;
  }

  const handleClick = (button: SuggestionButton) => {
    if (onSendMessage) {
      onSendMessage(button.text);
      setClicked(true);
    }
  };

  return (
    <div className="suggestion-buttons-container">
      {data.buttons.map((button, index) => (
        <button
          key={`${button.action}-${index}`}
          type="button"
          className="suggestion-button"
          onClick={() => handleClick(button)}
        >
          {button.text}
        </button>
      ))}
    </div>
  );
};
